const getApiBaseUrl = () => {
    // Si hay una variable de entorno definida explícitamente en React (REACT_APP_API_URL), úsala
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }

    if (typeof window !== 'undefined') {
        const { protocol, hostname, port } = window.location;

        // Dominios Nginx Proxy Manager
        if (hostname === 'pagos-procura.test') return `${protocol}//pagos-procura-api.test`;
        if (hostname === 'pagos-dev.test') return `${protocol}//pagos-dev-api.test`;
        if (hostname === 'pagos-main.test') return `${protocol}//pagos-main-api.test`;

        // Puertos locales Docker
        if (port === '3111') return `${protocol}//${hostname}:5111`;
        if (port === '3112') return `${protocol}//${hostname}:5112`;
        if (port === '3113') return `${protocol}//${hostname}:5113`;

        // Entornos AWS / Dominio principal
        if (hostname.includes('grupoeseasa.com')) {
            return `${protocol}//${hostname}`;
        }

        // Entornos de producción externa
        if (hostname === 'pagos.eseasaoffshore.com' || hostname === 'grupoeseasa.dsmynas.com') {
            return 'https://pagos.eseasaoffshore.com';
        }

        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return `${protocol}//${hostname}:5111`;
        }

        return `${protocol}//${hostname}:5111`;
    }

    return 'http://localhost:5111';
};

const config = {
    apiBaseUrl: getApiBaseUrl(),
    apiBaseRest: 'https://tytsoftwaredemexico.com.mx:4210',
};

export default config;
